<template>
  <div class="pd-l-10 pd-b-10 pd-t-10" @click="onItemClick">
    <div class="fs-16 text-ellipsis-2 mg-r-10">
      <span v-if="card.mark" class="pd-l-6 pd-r-6 display-inline-block lh-18 h-18 bdr-2 fs-10 mg-r-5"
            style="background: linear-gradient(51deg, #262626 0%, #545454 100%);color: #FFC680;vertical-align: middle;"
      >{{ card.mark }}</span>
      <span class="text-strong" style="vertical-align: middle;color: #646566">{{ card.title }}</span>
    </div>
    <div class="justify-content-space-between mg-t-30 fs-14 align-items-center mg-r-10">
      <div class="fs-14 c-app-green text-align-right">
        {{ card.subjectName }}
      </div>
      <div class="align-items-center">
        <!--<div>-->
        <!--{{card.hotValue}}-->
        <!--</div>-->
        <div class="c-app-orange" v-if="card.price > 0">
          <template v-if="isIos && appInner">{{ card.price / 100 }}资源币</template>
          <template v-else>￥{{ card.price / 100 }}</template>
        </div>
        <div class="c-app-orange" v-else>免费</div>
      </div>
    </div>
    <!--    <div class="fs-10 justify-content-space-between align-items-center c-9 mg-t-5 mg-r-10">
          <div class="justify-content-center align-items-center fs-11">
            <van-image
                round
                width="1.3rem"
                height="1.3rem"
                :src="card.userAvatar"
            />
            <span class="mg-l-4">{{card.userNickname}}</span>
          </div>
          &lt;!&ndash;<div>{{card.evaluateUserCount}}人评分</div>&ndash;&gt;
          <div v-if="card.evaluateUserCount >= 5" class="align-items-center">
            <div class="mg-t-2 mg-l-5">{{ card.score }} 评分 {{ card.hotValue }}</div>
          </div>
          <div v-else class="align-items-center">
            评分累积中
          </div>
        </div>-->
  </div>
</template>

<script>
import request from "@/libs/api.request";

export default {
  name: "cardItem",
  data() {
    return {
      appInner: false,
      isIos: false,
    }
  },
  props: ['card'],
  methods: {
    onItemClick() {
      this.$router.push({path: '/card/' + this.card.cardId})
    },
  },
  mounted() {
    this.appInner = this.$parent.appInner;
    this.isIos = this.$parent.isIos;
  }
}
</script>

<style scoped>

</style>
